export default __webpack_public_path__ + "static/media/in-article-light-image.829a8e00.png";